import React from "react";
import { MenuItem } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import { STEP_READABLE_ACTION_TYPES } from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
import { MODAL_TYPES } from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/Modals";
const BulkActions = ({ selectedStepsMap }) => {
  var _a, _b;
  const { entity, setModal, setEntity } = useModalContext();
  const stepValues = Object.values(selectedStepsMap != null ? selectedStepsMap : {});
  const stepActionType = (_a = stepValues == null ? void 0 : stepValues[0]) == null ? void 0 : _a.stepActionType;
  const stepId = (_b = stepValues == null ? void 0 : stepValues[0]) == null ? void 0 : _b.stepId;
  const eventIds = stepValues.reduce((acc, value) => [.../* @__PURE__ */ new Set([...acc, ...value.eventIds])], []);
  const onClick = () => {
    setEntity({ ...entity, stepId, stepActionType, eventIds });
    setModal(MODAL_TYPES.BULK_PERFORM_STEP_ACTION);
  };
  return /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, /* @__PURE__ */ React.createElement(MenuItem, { onClick }, STEP_READABLE_ACTION_TYPES[stepActionType]));
};
export default BulkActions;
